import { Camelized } from 'humps';
import { sdk } from 'src/utilities/sdk';
import { FieldsResponse } from 'src/types/CorporateFieldsData';
import { camelizeResponseData } from 'src/utilities/http-data-casing';

export const CORPORATE_FIELDS_ENDPOINT = '/corp-admin/corp/field_data';

export async function getCorporateFieldsData(): Promise<
  Camelized<FieldsResponse>
> {
  const data = await sdk.http.get(CORPORATE_FIELDS_ENDPOINT);
  return camelizeResponseData(data);
}
